import type { Referral } from './referrals-store';

/**
 * Per-status "…" action-menu contents for the referrals console (SCRUM-332) —
 * extracted from ReferralsTable so the component file exports only components
 * (react-refresh/only-export-components rule).
 */
export type ReferralMenuAction =
  | 'approve'
  | 'markReviewed'
  | 'seeProfile'
  | 'reassign'
  | 'deny'
  | 'reopen';

export interface MenuItem {
  action: ReferralMenuAction;
  label: string;
  kind?: 'primary' | 'danger';
  disabled?: string; // tooltip explaining why
}

/** v6 per-status "…" menu contents. */
export function menuItemsFor(status: Referral['status']): MenuItem[] {
  switch (status) {
    case 'pending':
      return [
        { action: 'approve', label: 'Approve & start campaign', kind: 'primary' },
        { action: 'markReviewed', label: 'Mark as reviewed' },
        { action: 'seeProfile', label: 'See profile' },
        { action: 'reassign', label: 'Reassign…' },
        { action: 'deny', label: 'Deny referral', kind: 'danger' },
      ];
    case 'reviewed':
      return [
        { action: 'approve', label: 'Approve & start campaign', kind: 'primary' },
        { action: 'seeProfile', label: 'See profile' },
        { action: 'reassign', label: 'Reassign…' },
        { action: 'deny', label: 'Deny referral', kind: 'danger' },
      ];
    case 'denied':
      return [
        {
          action: 'approve',
          label: 'Approve & start campaign',
          kind: 'primary',
          disabled: 'This referral was denied. Reopen it to take action.',
        },
        { action: 'seeProfile', label: 'See profile' },
        { action: 'reopen', label: 'Reopen referral' },
      ];
    case 'campaign_sent':
      return [
        {
          action: 'approve',
          label: 'Approve & start campaign',
          kind: 'primary',
          disabled: 'Campaign already sent for this referral.',
        },
        {
          action: 'deny',
          label: 'Deny referral',
          kind: 'danger',
          disabled: 'Campaign already sent for this referral.',
        },
        { action: 'seeProfile', label: 'See profile' },
      ];
  }
}
